import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { fromGlobalId } from 'graphql-relay';
import { FormattedDate, FormattedMessage, defineMessages } from 'react-intl';
import { Link } from 'react-router';
import HighSchoolDetailsComponent from '../HighSchoolDetailsDisplay';
import Modal from '../../components/Modal';
import Grid from '../../components/Grid';
import Button from '../../components/Button';
import REPVISITS_LOCATION_TYPE from '../../utils/repvisits-location-types';

import './styles.css';

const messages = defineMessages({
  yourSchedule: {
    id: 'repvisits.overview.yourSchedule',
    defaultMessage: 'Your Schedule |',
  },
  pending: {
    id: 'repvisits.overview.pending',
    defaultMessage: 'Pending',
  },
  scheduleFair: {
    id: 'repvisits.overview.scheduleFair',
    defaultMessage: 'Fair',
  },
  scheduleVisit: {
    id: 'repvisits.overview.scheduleVisit',
    defaultMessage: 'Visit',
  },
  scheduleInPersonVisit: {
    id: 'repvisits.overview.scheduleInPersonVisit',
    defaultMessage: 'In-person visit',
  },
  scheduleVirtualVisit: {
    id: 'repvisits.overview.scheduleVirtualVisit',
    defaultMessage: 'Virtual visit',
  },
});

const closeButtonIcon = (
  <Button
    icon="close"
    className="close"
    styleName="close"
    aria-label="Close"
  />
);

const renderSchedule = (appointment) => {
  if (appointment.userBookingStatus === 'PENDING') {
    return (
      <div styleName="pending-symbol-container">
        <div styleName="font-label" data-cy="pending-appointment">
          <FormattedMessage {...messages.pending} />
          <div styleName="pending-symbol" />
        </div>
      </div>
    );
  } else if (appointment.collegeFairId) {
    return (
      <div styleName="fair-symbol-container">
        <div styleName="font-label" data-cy="fair-appointment">
          <FormattedMessage {...messages.scheduleFair} />
          <div styleName="fair-symbol" />
        </div>
      </div>
    );
  } else if (appointment.chosenVisitLocationType === REPVISITS_LOCATION_TYPE.VIRTUAL) {
    return (
      <div styleName="virtual-symbol-container">
        <div styleName="font-label" data-cy="virtual-visit-appointment">
          <FormattedMessage {...messages.scheduleVirtualVisit} />
          <div styleName="virtual-symbol" />
        </div>
      </div>
    );
  } else {
    return (
      <div styleName="in-person-symbol-container">
        <div styleName="font-label" data-cy="in-person-visit-appointment">
          <FormattedMessage {...messages.scheduleInPersonVisit} />
          <div styleName="in-person-visit-symbol" />
        </div>
      </div>
    );
  }
};

const RepVisitsYourScheduleAppointments = (repVisitsSchedule) => (
  <Grid styleName="item-container" stackable width={16}>
    <Grid.Row styleName="item-header">
      <Grid.Column styleName="item-header" width={16}>
        <FormattedDate value={`${repVisitsSchedule.date}T12:00:00`} month="long" day="numeric" year="numeric" />
      </Grid.Column>
    </Grid.Row>
    {get(repVisitsSchedule, 'appointments.length') && (
      repVisitsSchedule.appointments
        .filter((appointment) => get(appointment, 'id', false) && get(appointment, 'highSchool.id', false))
        .map((appointment) => (
          <Grid.Row styleName="item-details" key={appointment.id}>
            <Grid.Column styleName="item" width={12}>
              <span styleName="font-label">{appointment.startTime}</span> &nbsp;
              <Modal
                trigger={(
                  <h3 styleName="font-link">
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <Link href="#">
                      {get(appointment, 'highSchool.name')}
                    </Link>
                  </h3>
                )}
                styleName="details-modal"
                closeIcon={closeButtonIcon}
              >
                <HighSchoolDetailsComponent id={fromGlobalId(appointment.highSchool.id).id} />
              </Modal>
            </Grid.Column>
            <Grid.Column styleName="item" textAlign="right" width={4}>
              {renderSchedule(appointment)}
            </Grid.Column>
          </Grid.Row>
        )))}
  </Grid>
);

RepVisitsYourScheduleAppointments.propTypes = {
  repVisitsSchedule: PropTypes.shape({
    date: PropTypes.string,
    id: PropTypes.string,
    appointments: PropTypes.array,
  }),
};

export default RepVisitsYourScheduleAppointments;
